import { Component, OnInit } from '@angular/core';
import { Subject, of, Observable } from 'rxjs';
import {
  tap,
  distinctUntilChanged,
  debounceTime,
  switchMap,
  map,
  pluck,
  mergeMap
} from 'rxjs/operators';
import { CorporateAPIService } from '../api/corporate-api.service';
import { Store, Select } from '@ngxs/store';

import {
  CorporateActions,
  CorporateMatching
} from '../transaction-store/corporate-matching';

@Component({
  selector: 'app-corporate-matching',
  template: `
    <section class="container">
      <div class="row">
        <select-field
          class="col-12"
          label="Corporate Matching?"
          [items]="(corporateMatching$ | async).corporateSearch"
          [loading]="loading"
          [typeahead]="search"
          (blur)="setCorporate($event)"
          clearable="true"
          searchable="true"
        >
        </select-field>
      </div>
    </section>
  `
})
export class CorporateMatchingComponent implements OnInit {
  corporations = [];
  loading = false;
  search = new Subject<string>();
  @Select() corporateMatching$: Observable<CorporateMatching>;
  constructor(private lookupAPI: CorporateAPIService, private store: Store) {}

  ngOnInit() {
    this.search
      .pipe(
        tap(() => (this.loading = true)),
        distinctUntilChanged(),
        debounceTime(200)
      )
      .subscribe(
        (term: any) => {
          this.store.dispatch(new CorporateActions.SearchCorporate(term || ''));
          this.loading = false;
        },
        () => {
          this.corporations = [];
          this.loading = false;
        }
      );

    // manually trigger search with no search term
    this.search.next('');
  }

  setCorporate($event) {
    this.store.dispatch(new CorporateActions.SetCorporate($event));
  }
}
